import React, { useState } from 'react';

import { useRecoilValue } from 'recoil';

import InventoryStore from 'src/app_deprecated/stores/InventoryStore';

import { inventoryAtom } from 'src/app/state/inventory';

import { QueryBuilderMultiSelect } from './shared/query-builder-multi-select';

type BrandDropdownProps = {
  disabled?: boolean;
  onChange: (value: (number | string)[]) => void;
  values: string;
};

type Brand = {
  id: number;
  name: string;
};

export function BrandDropdown({ onChange, values, disabled = false }: BrandDropdownProps) {
  const [loading, setLoading] = useState(false);
  const { brands } = useRecoilValue(inventoryAtom);

  const transformedBrands: Brand[] = (brands || []).map((brand) => ({
    id: brand.BrandId,
    name: brand.BrandName,
  }));

  async function handleRefresh() {
    setLoading(true);
    await InventoryStore.refreshBrands();
    setLoading(false);
  }

  return (
    <QueryBuilderMultiSelect<Brand>
      automationIdPrefix='brand'
      defaultLabel='Select a brand'
      disabled={disabled}
      idKey='id'
      items={transformedBrands}
      loading={loading}
      nameKey='name'
      refreshData={handleRefresh}
      values={values}
      onChange={onChange}
    />
  );
}
